const {REACT_APP_API_BASE_URL, REACT_APP_API_VERSION} = process.env;

export class AdminApi {
    // defualt method for post request
    static PostDefualtMethod = {
        method: 'POST',
        headers: {
            'Content-Type':'application/json'
        },
        credentials: 'include',
        mode: 'cors'
    }

    static GetDefualtMethod = {
        ...AdminApi.PostDefualtMethod,
        method: 'GET'
    }

    static register (data) {
        return fetch(`${REACT_APP_API_BASE_URL}/${REACT_APP_API_VERSION}/admins`, {
            ...AdminApi.PostDefualtMethod,
            body: JSON.stringify(data)
        });
    }

    static getAllAdmins () {
        return fetch(`${REACT_APP_API_BASE_URL}/${REACT_APP_API_VERSION}/admins`, {
            ...AdminApi.GetDefualtMethod
        });
    }

    static getAdmin (adminID) {
        return fetch(`${REACT_APP_API_BASE_URL}/${REACT_APP_API_VERSION}/admins/${adminID}`, {
            ...AdminApi.GetDefualtMethod
        });
    }

    static updateAdmin (adminID, data) {
        return fetch(`${REACT_APP_API_BASE_URL}/${REACT_APP_API_VERSION}/admins/${adminID}`, {
            ...AdminApi.GetDefualtMethod,
            method: 'PUT',
            body: JSON.stringify(data)
        });
    }

    static deleteAdmin (adminID) {
        return fetch(`${REACT_APP_API_BASE_URL}/${REACT_APP_API_VERSION}/admins/${adminID}`, {
            ...AdminApi.GetDefualtMethod,
            method: 'DELETE'
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/admin.js